import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicantSearchClient } from 'api-clients/applicant-api-client';
import { PolicyClient } from 'api-clients/policy-api-client';
import { AvatarComponent } from 'src/shared/avatar/avatar.component';
import { CelebrationComponent } from 'src/shared/celebration/celebration.component';
import { CelebrationService } from 'src/shared/celebration/celebration.service';
import { ChipModule } from 'src/shared/ez-chip/chip.module';
import { materialModules } from 'src/shared/material.module';
import { NoValuePipe } from 'src/shared/pipes/noValue.pipe';
import { WorkspaceModule } from '../workspace/workspace.module';
import { HeaderComponent } from './header.component';
import { HeaderService } from './header.service';

@NgModule({
  declarations: [
    HeaderComponent,
  ],
  exports: [
    HeaderComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CelebrationComponent,
    CommonModule,
    materialModules,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    AvatarComponent,
    ChipModule,
    NoValuePipe,
    WorkspaceModule,
  ],
  providers: [
    { provide: PolicyClient, useValue: new PolicyClient() },
    { provide: ApplicantSearchClient, useValue: new ApplicantSearchClient() },
    HeaderService,
    CelebrationService,
  ],
})
export class HeaderModule { }
